import type { RouteObject } from 'react-router-dom';
import { RequireAdmin } from '../guards/RequireAdmin';
import RequireSurface from '../guards/RequireSurface';
import { surfaceRoutes } from './registry';
import { ADMIN_GAME_MODULES } from './adminModules';
import type { AdminGameModule } from './types';

/**
 * Game-owned surface routes (#817) for the authenticated layout: every
 * registered game's admin manifest, each route behind `RequireSurface` (the
 * active game must declare the surface — mirroring the server's
 * requireGameSurface 404) and, when the route names a tier, `RequireAdmin`
 * OUTSIDE it.
 */
export function gameSurfaceRoutes(
  modules: readonly AdminGameModule[] = ADMIN_GAME_MODULES,
): RouteObject[] {
  return surfaceRoutes(modules).map(
    ({ path, Component, surface, minRole, allowRoles }) => {
      const gated = (
        <RequireSurface surface={surface}>
          <Component />
        </RequireSurface>
      );
      return {
        path,
        element: minRole ? (
          <RequireAdmin minRole={minRole} allowRoles={allowRoles}>
            {gated}
          </RequireAdmin>
        ) : (
          gated
        ),
      };
    },
  );
}
